import React from 'react';
import { Wrench, Zap, Package, Infinity } from 'lucide-react';
const principles = [{
  icon: Wrench,
  title: 'Działa w praktyce — nie tylko na papierze',
  description: 'Każda strona to narzędzie gotowe do użycia na Twoich zajęciach dzisiaj. Nie podręcznik akademicki.'
}, {
  icon: Zap,
  title: 'Zacznij używać natychmiast',
  description: 'Bez uczenia się oprogramowania. Bez szkoleń. Otwórz PDF i zacznij prowadzić zajęcia.'
}, {
  icon: Package,
  title: 'Kompletny w każdym aspekcie',
  description: 'Obejmuje wszystko: plany lekcji, rotacje taktyczne, ocenę uczniów, zarządzanie grupą i komunikację z rodzicami.'
}, {
  icon: Infinity,
  title: 'Twoje na zawsze',
  description: 'Jednorazowa płatność. Brak miesięcznych opłat. Dostępne zawsze na każdym urządzeniu.'
}];
export function WhyDifferent() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-354">
      <div className="max-w-6xl mx-auto" data-id="element-355">
        <div className="text-center mb-8 md:mb-12" data-id="element-356">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-357">
            Dlaczego ten system jest inny
          </h2>
          <p className="text-base md:text-lg text-[#9BA3B5] max-w-2xl mx-auto" data-id="element-358">
            Żadnej teorii. Żadnych miesięcznych subskrypcji. Żadnych drogich
            konsultantów. Tylko gotowe narzędzia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-359">
          {principles.map((principle, index) => {
          const Icon = principle.icon;
          return <div key={index} className="bg-[#1A3257] rounded-2xl p-6 md:p-8 shadow-lg border border-[#1E3A5F] flex flex-col h-full" data-id="element-360">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gold-accent/10 rounded-xl flex items-center justify-center mb-4" data-id="element-361">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-gold-accent" data-id="element-362" />
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-white mb-2 md:mb-3" data-id="element-363">
                  {principle.title}
                </h3>
                <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed flex-grow" data-id="element-364">
                  {principle.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}